interface VideoEmbedProps {
  title: string;
  src: string;
  tags?: string[];
}

export default function VideoEmbed({ title, src, tags }: VideoEmbedProps) {
  return (
    <div>
      <div className="video-embed card rounded-lg overflow-hidden">
        <iframe
          src={src}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      <p className="mt-2 text-sm font-medium">{title}</p>
      {tags && tags.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-1">
          {tags.map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
        </div>
      )}
    </div>
  );
}
